import StaffRepository from './staffRepository';
import DepartmentsRepository from './departmentsRepository';
import PermissionsRepository from './PermissionsRepository';
import RolesRepository from './RolesRepository';
import GlobalRepository from './GlobalRepository';
import FileRepository from "@/repository/FileRepository";
import NotificationsRepository from "@/repository/NotificationsRepository";
import UserRepository from "@/repository/userRepository";
import TenantRepository from "@/repository/TenantRepository";
import PricingRepository from "@/repository/PricingRepository";
import InvoiceRepository from "@/repository/InvoiceRepository";
import CustomerRepository from "@/repository/CustomerRepository";
import CountryCodeRepository from "@/repository/CountryCodeRepository";
import SettingRepository from "@/repository/SettingRepository";
import GoCardlessRepository from "@/repository/GoCardlessRepository";
import CurrencyRepository from "@/repository/CurrencyRepository";
import HelpTagRepository from '@/repository/HelpTagRepository';
import SupplierRepository from '@/repository/SupplierRepository';
import ChannelPartnerRepository from '@/repository/ChannelPartnerRepository'
import ProspectCustomerRepository from '@/repository/ProspectCustomerRepository'
import LocalizationRepository from '@/repository/LocalizationRepository'
import InProductCommunicationRepository from '@/repository/InProductCommunicationRepository';
import ExternalServiceRepository from '@/repository/ExternalServiceRepository';
import SettingsRepository from '@/repository/SettingsRepository';

const repositories = {
  staff : StaffRepository,
  departments : DepartmentsRepository,
  permissions : PermissionsRepository,
  roles : RolesRepository,
  global: GlobalRepository,
  file: FileRepository,
  notification: NotificationsRepository,
  user: UserRepository,
  tenant: TenantRepository,
  pricing: PricingRepository,
  invoice: InvoiceRepository,
  customer: CustomerRepository,
  countryCode: CountryCodeRepository,
  settings: SettingRepository,
  goCardless: GoCardlessRepository,
  currency: CurrencyRepository,
  helpTag: HelpTagRepository,
  supplier: SupplierRepository,
  channel_partner: ChannelPartnerRepository,
  prospect_customer: ProspectCustomerRepository,
  localization: LocalizationRepository,
  inProductCommunication: InProductCommunicationRepository,
  external: ExternalServiceRepository,
  landlord_settings: SettingsRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
